import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DISPLAY_DATE_FORMAT } from '../../../common';
import { ButtonAction } from '../../action-button/constants';
import {
  TRANSPORTATION_TRACKING_DATES_CONFIG,
  TransportationTrackingActionType,
  TransportationTrackingAllTypesDatesModel,
  TransportationTrackingDateType,
} from '../transportation-tracking.constant';
import { LoadOverview, TransportOrderOverview } from '../../../store';

@Component({
  selector: 'lib-transportation-tracking-dates-dialog',
  templateUrl: './transportation-tracking-dates-dialog.component.html',
  styleUrls: ['./transportation-tracking-dates-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportationTrackingDatesDialogComponent {
  buttonAction = ButtonAction;
  dateFormat = DISPLAY_DATE_FORMAT;
  transportationTrackingDateType = TransportationTrackingDateType;
  transportationTrackingActionType = TransportationTrackingActionType;

  dateFieldsConfig: TransportationTrackingAllTypesDatesModel;

  constructor(
    public dialogRef: MatDialogRef<TransportationTrackingDatesDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      actionType: TransportationTrackingActionType;
      overview: TransportOrderOverview | LoadOverview;
    },
  ) {
    this.dateFieldsConfig = TRANSPORTATION_TRACKING_DATES_CONFIG[data.actionType];
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
